import React, { useEffect } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { flattenData, getDaysBetweenMonths } from "../../../../Utilitie";
import * as echarts from "echarts";

const AvgMWPWIIntAndNintGraph = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedRT,
  selectedFy,
  int,
}) => {
  const mon = new Date().toLocaleString("en-US", { month: "short" });
  const date = new Date().getDate() - 1;

  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};

  useEffect(() => {
    if (selectedMonths.length === 0 || selectedSections.length === 0) return;

    const chartDom = document.getElementById("pwiAvgChart5");
    if (!chartDom) return;

    let myChart = echarts.init(chartDom);

    ////////////////////// PREV INT //////////////////////
    const prevLTotalIntTO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b = getDaysBetweenMonths(
            selectedFy.replace(/\d+/g, (y) => +y - 1).slice(0, 4),
            month.slice(0, 3).toUpperCase(),
            month.slice(0, 3).toUpperCase(),
          );
          const d = getSectionData(m, s);
          return (
            acc + Number(d[`${selectedRT.toLowerCase()}_to_intensive`] || 0) / b
          );
        }, 0)
        .toFixed(1);
    });

    ////////////////////// CURR INT //////////////////////
    const currLTotalIntTO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b =
            Number(selectedFy.slice(0, 4)) === new Date().getFullYear() &&
            month.slice(0, 3) === mon
              ? date
              : getDaysBetweenMonths(
                  selectedFy.slice(0, 4),
                  month.slice(0, 3).toUpperCase(),
                  month.slice(0, 3).toUpperCase(),
                );
          const d = getSectionData(m, s);
          return (
            acc + Number(d[`${selectedRT.toLowerCase()}_to_intensive`] || 0) / b
          );
        }, 0)
        .toFixed(1);
    });

    ////////////////////// PREV N-INT //////////////////////
    const prevETotalNIntTO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b = getDaysBetweenMonths(
            selectedFy.replace(/\d+/g, (y) => +y - 1).slice(0, 4),
            month.slice(0, 3).toUpperCase(),
            month.slice(0, 3).toUpperCase(),
          );
          const d = getSectionData(m, s);
          return (
            acc +
            Number(d[`${selectedRT.toLowerCase()}_to_nonintensive`] || 0) / b
          );
        }, 0)
        .toFixed(1);
    });

    ////////////////////// CURR N-INT //////////////////////
    const currETotalNIntTO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b =
            Number(selectedFy.slice(0, 4)) === new Date().getFullYear() &&
            month.slice(0, 3) === mon
              ? date
              : getDaysBetweenMonths(
                  selectedFy.slice(0, 4),
                  month.slice(0, 3).toUpperCase(),
                  month.slice(0, 3).toUpperCase(),
                );
          const d = getSectionData(m, s);
          return (
            acc +
            Number(d[`${selectedRT.toLowerCase()}_to_nonintensive`] || 0) / b
          );
        }, 0)
        .toFixed(1);
    });

    ////////////////////// CHART OPTION //////////////////////
    const option = {
      title: {
        text: `INT & N-INT Avg Per Day Comparison – Prev (${selectedFy.replace(
          /\d+/g,
          (y) => +y - 1,
        )}) vs Curr Year (${selectedFy})`,
        left: "center",
      },
      tooltip: { trigger: "axis" },
      legend: {
        top: 30,
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "10%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: selectedMonths,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name:
            int === "Int"
              ? `INT (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`
              : `N-INT (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          type: "bar",
          data: int === "Int" ? prevLTotalIntTO : prevETotalNIntTO,
          label: { show: true, position: "top" },
        },
        {
          name: int === "Int" ? `INT (${selectedFy})` : `N-INT (${selectedFy})`,
          type: "bar",
          data: int === "Int" ? currLTotalIntTO : currETotalNIntTO,
          label: { show: true, position: "top" },
        },
        // {
        //   name: `N-INT (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
        //   type: "bar",
        //   data: prevETotalNIntTO,
        //   label: { show: true, position: "top" },
        // },
        // {
        //   name: `N-INT (${selectedFy})`,
        //   type: "bar",
        //   data: currETotalNIntTO,
        //   label: { show: true, position: "top" },
        // },
      ],
    };

    myChart.setOption(option);

    const handleResize = () => {
      myChart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      myChart.dispose();
    };
  }, [
    selectedMonths,
    selectedSections,
    sortedPrev,
    sortedCurr,
    selectedRT,
    selectedFy,
  ]);

  return (
    <div className="papaDiv">
      <div
        id="pwiAvgChart5"
        style={{ width: "100%", height: "50vh", marginTop: "30px" }}
      />
    </div>
  );
};

export default AvgMWPWIIntAndNintGraph;
